export default {"src":"/_next/static/media/reebelo-badge.98857676.svg","height":70,"width":148};